import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  bodyText: {
    id: 'report.footer.bodyText',
    description: 'Footer text content',
    defaultMessage:
      'Vastuu Group Oy ei vastaa käyttäjälle tai kolmannelle osapuolelle Zeckit -palvelun mahdollisesti sisältämistä virheistä tai puutteellisuuksista tai palvelun sisältämien tietojen käytöstä tai tulkinnasta aiheutuvista välittömistä tai välillisistä vahingoista. Suomen Tilaajavastuu Oy vastaa kuitenkin siitä, että se on hankkinut Zeckit -palvelussa olevat yrityksen tiedot luotettavasta lähteestä. Suomen Tilaajavastuu Oy ei ota mitään vastuuta palvelun käyttäjien antamista arviointitiedoista. Vastuu Group Oy ei myöskään vastaa Zeckit –palvelun tai Zeckit –palvelun tietojen soveltuvuudesta ja sopivuudesta mihinkään tiettyyn tarkoitukseen.',
  },
});
